import type { ApplyV2SettingsSectionName, GetApplyV2SettingsResponse } from '@core/app/types/applyV2Type'
import React from 'react'
import './ApplyV2QuestionsStep.scss'

interface Props {
    settingsData: GetApplyV2SettingsResponse | null | undefined
    navItems: {
        name: ApplyV2SettingsSectionName
        visible: boolean
        required: boolean
        order: number
    }[]
}

const baseClass = 'ApplyV2QuestionsStep'

function ApplyV2QuestionsStep({ settingsData, navItems }: Props) {
    return <div className={baseClass}>ApplyV2QuestionsStep</div>
}

export default ApplyV2QuestionsStep
